/*  iceberg-ui  */
import { Box } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { Link, useParams } from 'react-router';

/**
 * A wrapper component that handles routing for contract-related views
 * @param handleModalViewTabChange - Callback function to handle tab changes in modal view
 * @param modalView - Boolean flag indicating if component is rendered in modal view
 * @param children - Child components/elements to be wrapped
 * @returns Either a Box component with onClick/handleModalViewTabChange (for modal view) or Link component (for regular view)
 */
export const ContractRouteWrapper = ({
    handleModalViewTabChange,
    modalView,
    children
}: {
    handleModalViewTabChange?: (
        _e: React.SyntheticEvent,
        value: string
    ) => void;
    modalView?: boolean;
    children: React.ReactNode;
}) => {
    const { applicationId, clientId, partnerId } = useParams();
    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId: clientId!,
        partnerId
    });
    return modalView ? (
        <Box
            as="span"
            onClick={(e: React.SyntheticEvent) => {
                if (handleModalViewTabChange) {
                    handleModalViewTabChange(e, 'contract');
                }
            }}
        >
            {children}
        </Box>
    ) : (
        <Link to={`${baseAdminRoute}/application/${applicationId}/contract`}>
            {children}
        </Link>
    );
};
